import React from 'react';
import {
  FormControl,
  IconButton,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import LockOutlined from '@material-ui/icons/LockOutlined';
import lowerFirst from 'lodash-es/lowerFirst';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import classNames from 'clsx';

import { PasswordControlProps } from './PasswordControl.interfaces';
import { UtilService } from 'app/services/util.service';
import { ControlContainer } from 'app/components/ControlContainer';
import { usePasswordControl } from 'app/shared/hooks/controls/usePasswordControl';
import { useStyles } from './PasswordControl.styles';

const PasswordControl = (props: PasswordControlProps) => {
  const {
    input,
    isQuestionValid,
    disabled,
    meta,
    subLabel,
    helperText,
    tooltip,
    width,
    label,
    toggleVisibility,
    placeholder,
  } = props;

  const {
    error,
    focused,
    setFocused,
    handleBlur,
    handleChange,
    handleClick,
    toggleShowPassword,
    showPassword,
  } = usePasswordControl(props);

  const classes = useStyles();

  return (
    <FormControl fullWidth>
      <ControlContainer
        inputId={input.name}
        tooltip={tooltip}
        label={label}
        subLabel={subLabel}
        helperText={helperText}
        floating
        floated
        focused={focused}
        classes={{ label: classes.label }}
        meta={meta}
        width={width}
      >
        <LockOutlined
          className={classNames(
            {
              [classes.activeIcon]:
                isQuestionValid && UtilService.hasValue(input.value),
            },
            classes.icon
          )}
        />
        <TextField
          {...input}
          id={input.name}
          fullWidth
          disabled={disabled}
          inputProps={{
            className: classes.textField,
          }}
          onChange={handleChange}
          onBlur={handleBlur}
          onClick={handleClick}
          onFocus={() => setFocused(true)}
          type={showPassword ? 'text' : 'password'}
          error={error}
          variant={'outlined'}
          margin={'dense'}
          autoComplete="current-password"
          placeholder={placeholder || lowerFirst(label)}
          InputProps={{
            endAdornment: toggleVisibility && (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onMouseDown={toggleShowPassword}
                  onMouseUp={toggleShowPassword}
                  onTouchStart={toggleShowPassword}
                  onTouchEnd={toggleShowPassword}
                  edge="end"
                  className={classes.iconButton}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </ControlContainer>
    </FormControl>
  );
};

export default PasswordControl;
